import { CheckCircle2, XCircle } from "lucide-react";
import { useI18n } from "../../i18n";

export default function WhoFor() {
  const { t } = useI18n();
  const FOR = ["for1", "for2", "for3", "for4", "for5", "for6"];
  const NOT = ["not1", "not2", "not3", "not4", "not5"];
  return (
    <section className="relative py-16 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="chip">{t("whofor_chip")}</span>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.05]">
            {t("whofor_h1_a")} <span className="text-[color:var(--gold)]">{t("whofor_h1_b")}</span>
          </h2>
          <p className="text-[color:var(--ink-dim)] mt-4 leading-relaxed text-sm sm:text-base">{t("whofor_sub")}</p>
        </div>

        <div className="mt-8 sm:mt-10 grid md:grid-cols-2 gap-3 sm:gap-4">
          <div className="panel p-5 sm:p-8" style={{ borderColor: "rgba(0,255,136,.25)" }}>
            <div className="flex items-center gap-2 mb-4 sm:mb-5">
              <CheckCircle2 className="w-5 h-5 text-[color:var(--green)]" />
              <div className="font-display font-bold text-base sm:text-lg">{t("whofor_for_title")}</div>
            </div>
            <ul className="space-y-2.5 sm:space-y-3">
              {FOR.map((k) => (
                <li key={k} className="flex gap-3 text-[13px] sm:text-sm text-[color:var(--ink-dim)]">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[color:var(--green)] shrink-0" />{t(k)}
                </li>
              ))}
            </ul>
          </div>

          <div className="panel p-5 sm:p-8" style={{ borderColor: "rgba(255,92,92,.25)" }}>
            <div className="flex items-center gap-2 mb-4 sm:mb-5">
              <XCircle className="w-5 h-5 text-[#ff9c9c]" />
              <div className="font-display font-bold text-base sm:text-lg">{t("whofor_not_title")}</div>
            </div>
            <ul className="space-y-2.5 sm:space-y-3">
              {NOT.map((k) => (
                <li key={k} className="flex gap-3 text-[13px] sm:text-sm text-[color:var(--ink-dim)]">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#ff9c9c] shrink-0" />{t(k)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
